export const AVATAR_BO_PERMISSIONS = {
  catalogueWrite: 'avatar_studio.catalogue.write',
  versionApprove: 'avatar_studio.version.approve',
  versionPublish: 'avatar_studio.version.publish',
  snapshotCreate: 'avatar_studio.snapshot.create',
} as const

export type AvatarBoPermission =
  (typeof AVATAR_BO_PERMISSIONS)[keyof typeof AVATAR_BO_PERMISSIONS]

export const AVATAR_BO_PERMISSION_LIST: AvatarBoPermission[] = Object.values(
  AVATAR_BO_PERMISSIONS,
)
